export const organizationPath = {
  /* inject path */
  ADD_NEW_ORGANIZATION: '/organizations/add-new-organization',
  EDIT_ORGANIZATION: '/organizations/edit-organization/:id',
  EDIT_ORGANIZATION_URI: '/organizations/edit-organization',
  ORGANIZATION_DETAILS: '/organizations/organization-details/:id',
  ORGANIZATION_DETAILS_URI: '/organizations/organization-details',
  ORGANIZATION_TABLE: '/organizations/organization-table',
  DASHBOARD: '/organizations/dashboard',
};
